<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>receipt_long</mat-icon>
      <span class="modal-header-titulo-texto">Imprimir Serviço Tomado</span>
    </h2>
    <button mat-icon-button (click)="fechar()" class="modal-header-fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-body">
    @if (isLoading) {
    <div class="d-flex justify-content-center py-5 no-print">
      <mat-spinner [diameter]="32"></mat-spinner>
    </div>
    } @else if (detalhe) {

    <div class="comprovante-print-container">
      <div class="comprovante-header">
        <div>
          <div class="comprovante-empresa">{{ nomeEmpresa }}</div>
          @if (cnpjEmpresaFormatado) {
          <div class="comprovante-empresa-doc">CNPJ: {{ cnpjEmpresaFormatado }}</div>
          }
        </div>
        <div class="comprovante-titulo-wrapper">
          <div class="comprovante-titulo">COMPROVANTE DE SERVIÇO TOMADO</div>
          <div class="comprovante-subtitulo">NFS-e de entrada (lançamento manual) · Nº {{ detalhe.numeroNFSe }}
            @if (detalhe.serieDps) { · Série {{ detalhe.serieDps }} }
          </div>
        </div>
      </div>

      <div class="comprovante-linha-status">
        <span><strong>Status:</strong> {{ statusLabel }}</span>
        <span><strong>Emissão:</strong> {{ detalhe.datetimeEmissaoDps | date:'dd/MM/yyyy' }}</span>
        <span><strong>Entrada:</strong> {{ detalhe.dataExecucaoEntrada | date:'dd/MM/yyyy' }}</span>
      </div>

      <div class="comprovante-secao">
        <div class="comprovante-secao-titulo">Remetente (Emitente)</div>
        <div class="comprovante-grid">
          <div><strong>Nome:</strong> {{ detalhe.nomeEmitente }}</div>
          @if (documentoEmitenteFormatado) {
          <div><strong>Documento:</strong> {{ documentoEmitenteFormatado }}</div>
          }
          @if (detalhe.inscricaoMunicipal) {
          <div><strong>Inc. Municipal:</strong> {{ detalhe.inscricaoMunicipal }}</div>
          }
          @if (detalhe.telefone) {
          <div><strong>Fone:</strong> {{ detalhe.telefone }}</div>
          }
          @if (detalhe.email) {
          <div><strong>Email:</strong> {{ detalhe.email }}</div>
          }
          <div class="comprovante-grid-full"><strong>Endereço:</strong> {{ enderecoFormatado }}</div>
        </div>
      </div>

      <div class="comprovante-secao">
        <div class="comprovante-secao-titulo">Serviço</div>
        <div class="comprovante-grid">
          <div class="comprovante-grid-full"><strong>Descrição:</strong> {{ detalhe.descricaoServico }}</div>
          <div><strong>Valor do Serviço:</strong> {{ formatarValor(detalhe.valorServico) }}</div>
          @if (naturezaLabel) {
          <div><strong>Natureza da Base de Cálculo do Crédito:</strong> {{ naturezaLabel }}</div>
          }
          @if (origemLabel) {
          <div><strong>Origem do Crédito:</strong> {{ origemLabel }}</div>
          }
        </div>
      </div>

      @if (temImpostosRetidos) {
      <div class="comprovante-secao">
        <div class="comprovante-secao-titulo">Impostos Retidos</div>
        <div class="comprovante-tabela-scroll">
          <table class="comprovante-tabela">
            <thead>
              <tr>
                <th>Tributo</th>
                <th class="text-end">Base (R$)</th>
                <th class="text-end">Alíquota (%)</th>
                <th class="text-end">Valor (R$)</th>
              </tr>
            </thead>
            <tbody>
              @if (detalhe.irValor) {
              <tr>
                <td>IR</td>
                <td class="text-end">{{ formatarValor(detalhe.irBase) }}</td>
                <td class="text-end">{{ detalhe.irAliquota || 0 }}%</td>
                <td class="text-end">{{ formatarValor(detalhe.irValor) }}</td>
              </tr>
              }
              @if (detalhe.inssValor) {
              <tr>
                <td>INSS</td>
                <td class="text-end">{{ formatarValor(detalhe.inssBase) }}</td>
                <td class="text-end">{{ detalhe.inssAliquota || 0 }}%</td>
                <td class="text-end">{{ formatarValor(detalhe.inssValor) }}</td>
              </tr>
              }
              @if (detalhe.issValor) {
              <tr>
                <td>ISS</td>
                <td class="text-end">{{ formatarValor(detalhe.issBase) }}</td>
                <td class="text-end">{{ detalhe.issAliquota || 0 }}%</td>
                <td class="text-end">{{ formatarValor(detalhe.issValor) }}</td>
              </tr>
              }
              @if (detalhe.pisRetidoValor) {
              <tr>
                <td>PIS</td>
                <td class="text-end">—</td>
                <td class="text-end">{{ detalhe.pisRetidoAliquota || 0 }}%</td>
                <td class="text-end">{{ formatarValor(detalhe.pisRetidoValor) }}</td>
              </tr>
              }
              @if (detalhe.cofinsRetidoValor) {
              <tr>
                <td>COFINS</td>
                <td class="text-end">—</td>
                <td class="text-end">{{ detalhe.cofinsRetidoAliquota || 0 }}%</td>
                <td class="text-end">{{ formatarValor(detalhe.cofinsRetidoValor) }}</td>
              </tr>
              }
              @if (detalhe.csllRetidoValor) {
              <tr>
                <td>CSLL</td>
                <td class="text-end">—</td>
                <td class="text-end">{{ detalhe.csllRetidoAliquota || 0 }}%</td>
                <td class="text-end">{{ formatarValor(detalhe.csllRetidoValor) }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      }

      @if (temImpostosCreditados) {
      <div class="comprovante-secao">
        <div class="comprovante-secao-titulo">Impostos Creditados</div>
        <div class="comprovante-tabela-scroll">
          <table class="comprovante-tabela">
            <thead>
              <tr>
                <th>Tributo</th>
                <th>CST</th>
                <th class="text-end">Base (R$)</th>
                <th class="text-end">Alíquota (%)</th>
                <th class="text-end">Valor (R$)</th>
              </tr>
            </thead>
            <tbody>
              @if (detalhe.pisCreditado?.valor) {
              <tr>
                <td>PIS/Pasep</td>
                <td>{{ detalhe.pisCreditado?.codigoCst || '—' }}</td>
                <td class="text-end">{{ formatarValor(detalhe.pisCreditado?.baseCalculo) }}</td>
                <td class="text-end">{{ detalhe.pisCreditado?.aliquota || 0 }}%</td>
                <td class="text-end">{{ formatarValor(detalhe.pisCreditado?.valor) }}</td>
              </tr>
              }
              @if (detalhe.cofinsCreditado?.valor) {
              <tr>
                <td>COFINS</td>
                <td>{{ detalhe.cofinsCreditado?.codigoCst || '—' }}</td>
                <td class="text-end">{{ formatarValor(detalhe.cofinsCreditado?.baseCalculo) }}</td>
                <td class="text-end">{{ detalhe.cofinsCreditado?.aliquota || 0 }}%</td>
                <td class="text-end">{{ formatarValor(detalhe.cofinsCreditado?.valor) }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      }

      <div class="comprovante-secao">
        <div class="comprovante-secao-titulo">Totais</div>
        <div class="comprovante-totais">
          <div><span>Valor Total</span><strong>{{ formatarValor(detalhe.valorTotal) }}</strong></div>
          <div><span>Valor Líquido a Pagar</span><strong>{{ formatarValor(detalhe.valorLiquido) }}</strong></div>
        </div>
      </div>

      @if (detalhe.condicaoPagamento || detalhe.parcelas?.length) {
      <div class="comprovante-secao">
        <div class="comprovante-secao-titulo">Pagamento</div>
        @if (detalhe.condicaoPagamento) {
        <div class="mb-2"><strong>Condição de Pagamento:</strong> {{ detalhe.condicaoPagamento }}</div>
        }
        @if (detalhe.parcelas?.length) {
        <div class="comprovante-tabela-scroll">
          <table class="comprovante-tabela">
            <thead>
              <tr>
                <th>Parcela</th>
                <th>Vencimento</th>
                <th class="text-end">Valor (R$)</th>
              </tr>
            </thead>
            <tbody>
              @for (parcela of detalhe.parcelas; track parcela.numeroParcela) {
              <tr>
                <td>{{ parcela.numeroParcela }}</td>
                <td>{{ parcela.dataVencimento | date:'dd/MM/yyyy' }}</td>
                <td class="text-end">{{ formatarValor(parcela.valorParcela) }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        }
      </div>
      }

      @if (detalhe.observacaoInterna) {
      <div class="comprovante-secao">
        <div class="comprovante-secao-titulo">Observações</div>
        <div>{{ detalhe.observacaoInterna }}</div>
      </div>
      }

      <div class="comprovante-rodape">
        Comprovante gerado pelo ATS Hub em {{ dataGeracao | date:'dd/MM/yyyy HH:mm' }} — sem valor fiscal, apenas
        controle interno.
      </div>
    </div>
    }
  </div>

  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Cancelar</button>
    <button mat-flat-button class="btn-primary" [disabled]="isLoading || !detalhe" (click)="imprimir()">
      <mat-icon>print</mat-icon>
      Imprimir
    </button>
  </div>
</div>
